import {
  Box,
  Button,
  FormControl,
  Flex,
  Heading,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import { useState } from 'react';
import axiosClient from '../../axios-client';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import image from "../../assets/images/signInImage.jpg";

const ResetPassword = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState("")
  const toast = useToast()
  const navigate = useNavigate()

  const { token } = useParams();

  const onSubmit = ev => {
    toast.closeAll()
    ev.preventDefault();
    if (email === "") {
      toast({
        description: t("Veuillez entrer votre adresse email"),
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top",
        variant: "left-accent"
      });
    } else {
      axiosClient.get('reset_email/', { params: { email: email } })
        .then((response) => {
          if (response.status === 203) {
            toast({
              description: response.data.message,
              status: "error",
              duration: 3000,
              isClosable: true,
              position: "top",
              variant: "left-accent"
            });
          } else {
            // Vider le localStorage pour éviter que l'ancien mot de passe ne soit utilisé lors de la prochaine connexion
            localStorage.removeItem("REMEMBERED_EMAIL");
            localStorage.removeItem("REMEMBERED_PASSWORD");

            toast({
              description: t("Un e-mail de réinitialisation de mot de passe a été envoyé, vérifiez votre boîte de réception"),
              status: "success",
              duration: 3000,
              isClosable: true,
              position: "top",
              variant: "left-accent"
            });
            navigate('/login')
          }

        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  return (
    <Flex
      alignItems={'center'} justifyContent={'center'}
      w={"100%"}
      position='relative' backgroundSize={'cover'} bgImage={image} h={'100vh'}
      overflow="hidden"
    >
      {/* Dark overlay */}
      <Box
        position="absolute"
        top={0} left={0} right={0} bottom={0}
        bg="blackAlpha.400"
        zIndex={0}
      />
        <Flex
        gap={5}
          w={{ base: "92%", sm: "85%", md: '460px' }}
          backdropFilter='blur(20px) saturate(180%)'
          WebkitBackdropFilter='blur(20px) saturate(180%)'
          padding={{ base: 8, md: 10 }}
          direction='column'
          rounded={"20px"}
          background='rgba(20, 15, 40, 0.75)'
          border="1px solid"
          borderColor="whiteAlpha.100"
          boxShadow="0 25px 60px -12px rgba(0,0,0,0.4), 0 0 40px -8px rgba(128, 90, 213, 0.1)"
          className="animate-scale-in"
          position="relative"
          zIndex={1}
        >
          <Heading
            color={"white"}
            lineHeight={1.1}
            fontSize={{ base: '24px', md: '28px' }}
            fontWeight="800"
            letterSpacing="-0.02em"
          >
            {t("Mot de passe oublié ?")}
          </Heading>
          <Text
            fontSize={{ base: 'sm', sm: '14px' }}
            color={'gray.400'}
            lineHeight="1.6"
          >
            {t("Entrez votre adresse email")}
          </Text>
          <FormControl id="email">
            <Input
              name='email'
              color={'white'}
              placeholder={t("votre-email@example.com")}
              _placeholder={{ color: 'whiteAlpha.400', fontSize: '14px' }}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              h="48px"
              bg="whiteAlpha.50"
              border="1px solid"
              borderColor="whiteAlpha.200"
              borderRadius="12px"
              fontSize="14px"
              _hover={{ borderColor: "whiteAlpha.300" }}
              _focus={{
                borderColor: "purple.400",
                boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)",
                bg: "whiteAlpha.100"
              }}
              transition="all 0.2s ease"
            />
          </FormControl>
          <Stack spacing={6}>
            <Button
              colorScheme='purple'
              name='submit'
              type='submit'
              onClick={onSubmit}
              h="48px"
              fontSize="14px"
              fontWeight="600"
              borderRadius="12px"
              bg="linear-gradient(135deg, #7B5EA7 0%, #9F7AEA 100%)"
              _hover={{
                bg: "linear-gradient(135deg, #6B4E97 0%, #8F6ADA 100%)",
                transform: "translateY(-1px)",
                boxShadow: "0 8px 25px -5px rgba(128, 90, 213, 0.4)"
              }}
              _active={{ transform: "scale(0.98)" }}
              transition="all 0.2s ease"
              letterSpacing="-0.01em"
            >
              {t("Demander une réinitialisation")}
            </Button>
          </Stack>
          <Text
            fontSize="13px"
            color="whiteAlpha.500"
            textAlign="center"
            cursor="pointer"
            _hover={{ color: "purple.300" }}
            transition="color 0.15s ease"
            onClick={() => navigate('/login')}
          >
            {t("Retour à la connexion")}
          </Text>
        </Flex>

    </Flex>
  )
}

export default ResetPassword